const header = {
  header: {
    logOut: 'Sair',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Suporte Enphase',
    comingSoon: 'Em breve',
    new: 'Novo'
  }
};
export default header;